/**
 * Vessel IDs that use autonomous-underwater-vehicle.png when category is AUV.
 * (Status / threat_detected are ignored so the icon does not flicker during exercise playback.)
 */
export const DEMO_AUV_RASTER_UUIDS = [
  '2db628f8-4a68-4e17-b6bf-cf15a22694b3',
  'c375714f-a390-4cb7-96c5-afb8e187790d',
  '3e89aaa6-15f2-4a8a-a0fb-95f723c36702'
];

function normalizeVesselCategoryKey(obj) {
  return String(
    obj?.common_name ??
      obj?.message_description_label ??
      obj?.message_description_name ??
      obj?.object_classification ??
      ''
  )
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

const isThreatOrUnknownUsvKey = (key) =>
  Boolean(key) && (key.includes('threat') || (key.includes('unknown') && key.includes('usv')));

function isDefensiveSurfaceVesselKey(key) {
  if (!key || isThreatOrUnknownUsvKey(key)) return false;
  return (
    key.includes('defensive_surface') ||
    key.includes('defense_usv') ||
    key.includes('defensive_usv') ||
    key.includes('surface_defense') ||
    key.includes('blue_force_usv')
  );
}

export function isAutonomousUnderwaterVehicleCategory(obj) {
  const key = normalizeVesselCategoryKey(obj);
  if (!key) return false;
  if (isDefensiveSurfaceVesselKey(key)) return false;
  if (/(^|_)auv(_|$)/.test(key)) return true;
  if (key.includes('autonomous_underwater')) return true;
  if (key.includes('underwater_vehicle')) return true;
  if (key.includes('uuv')) return true;
  return false;
}

function normalizeVesselUuid(obj) {
  return String(obj?.unique_identifier ?? obj?.id ?? '').trim().toLowerCase();
}

export function isDemoAuvRasterVessel(obj) {
  if (!obj) return false;
  const uid = normalizeVesselUuid(obj);
  if (!DEMO_AUV_RASTER_UUIDS.includes(uid)) return false;
  return isAutonomousUnderwaterVehicleCategory(obj);
}
